function initImageColumnSlider() {

  document
    .querySelectorAll(".image-column-slider")
    .forEach(function(section) {

      const autoplayEnabled =
        section.dataset.autoplay === "true";

      const autoplaySpeed =
        Number(section.dataset.speed) || 5000;


      /* =====================================
         Shared Swiper Options
      ===================================== */

      function getSwiperOptions(slider) {

        return {

          slidesPerView: 1,

          spaceBetween: 20,

          loop: false,

          speed: 700,

          grabCursor: true,

          preventClicks: true,

          preventClicksPropagation: true,

          allowTouchMove: true,

          autoplay: autoplayEnabled
            ? {
                delay: autoplaySpeed,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
              }
            : false,

          pagination: {
            el: slider.querySelector(".swiper-pagination"),
            clickable: true
          },

          navigation: {
            nextEl: slider.querySelector(".swiper-button-next"),
            prevEl: slider.querySelector(".swiper-button-prev")
          }

        };

      }


      /* =====================================
         Desktop / Tablet Slider
      ===================================== */

      const desktopSlider =
        section.querySelector(".image-slider-desktop-swiper");


      if (
        desktopSlider &&
        !desktopSlider.classList.contains("swiper-initialized")
      ) {

        new Swiper(
          desktopSlider,
          getSwiperOptions(desktopSlider)
        );

      }


      /* =====================================
         Mobile Slider
      ===================================== */

      const mobileSlider =
        section.querySelector(".image-slider-mobile-swiper");


      if (
        mobileSlider &&
        !mobileSlider.classList.contains("swiper-initialized")
      ) {

        new Swiper(
          mobileSlider,
          getSwiperOptions(mobileSlider)
        );

      }

    });

}


/* =====================================
   Initial Load
===================================== */

document.addEventListener(
  "DOMContentLoaded",
  initImageColumnSlider
);


/* =====================================
   Shopify Theme Editor
===================================== */

document.addEventListener(
  "shopify:section:load",
  function(event) {

    initImageColumnSlider();

  }
);